module.exports = __webpack_public_path__ + "static/media/logo.7523f78d.png";